import { prettifyError, z } from 'zod';
export function validateConfig(value) {
    return configSchema.parse(value);
}
export function getValidationPrettyError(value) {
    const error = configSchema.safeParse(value);
    if (error.error) {
        return prettifyError(error.error);
    }
    return null;
}
const requestKeySchema = z.enum([
    '1H',
    '1H_water_suppression',
    '13C',
    'DEPT_135',
    'APT',
    'COSY',
    'HSQC',
    'HMBC',
    'NOESY',
    '31P',
    '11B',
    '19F',
]);
const experimentSchema = z.object({
    requestKey: requestKeySchema.optional(),
    // If true, enable only if sample is a polymer (as per request)
    // If false, enable only if sample is NOT a polymer
    // If undefined, it does not matter if sample is a polymer
    isPolymer: z.boolean().optional(),
    enabled: z.boolean().optional(),
    experiment: z.string(),
    parameters: z.array(z.object({
        label: z.string(),
        value: z.string(),
    })),
});
const configSchema = z.object({
    // Mapping between solvent name show to user and Bruker / Icon NMR solvent name
    solventMapping: z.record(z.string(), z.string()),
    instruments: z.record(
    // Name of the instrument
    z.string(), 
    // Instrument configuration
    z.object({
        experiments: z.array(experimentSchema),
    })),
});
//# sourceMappingURL=instruments.js.map